import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-dados-nacionais',
  templateUrl: './consulta-dados-nacionais.component.html',
  styleUrls: ['./consulta-dados-nacionais.component.scss']
})
export class ConsultaDadosNacionaisComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo = "";
  @Input() idConsulta = "";
  @Input() tipoConsulta = "";
  @Input() codigoControle = "";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';
  @Input() nomeConsulta = 'binfederal';

  alienacao: String;
  arrendamento: String;
  restricaoAdministrativa: String;
  restricaoJudicial: String;
  reservaDominio: String;
  rouboFurto: String;
  reserva: String;
  restricaoTributaria: String;
  sinistroRecuperado: String;
  observacoes: String = "";
  listaRestricoes = [];
  possuiRouboFurtoFederal: boolean = false;
  dadosGravame = false;

  @Input() token = '';

  constructor() { }

  ngOnInit() { }

  ngOnChanges() {
    this.inicializaListaRestricoes();
    this.getRestricoes();
    this.verificaGravame();
    this.verificaRouboFurtoFederal();
  }

  inicializaListaRestricoes() {
    if (this.consulta && this.consulta.restricao) {
      this.listaRestricoes = this.consulta.restricao.split(';');
    }
  }

  verificaRouboFurtoFederal() {
    this.possuiRouboFurtoFederal = false;

    if(this.consulta) {
      if( this.consulta.restricao && this.consulta.restricao.toUpperCase().search('HISTÓRICO') == -1 && this.consulta.restricao.toUpperCase().search('HISTORICO') == -1 ) {
        this.consulta.restricao.toUpperCase().search('ROUBO') != -1 && !this.possuiRouboFurtoFederal ? this.possuiRouboFurtoFederal = true : false;
        this.consulta.restricao.toUpperCase().search('ROUBO/FURTO') != -1 && !this.possuiRouboFurtoFederal ? this.possuiRouboFurtoFederal = true : false;
        this.consulta.restricao.toUpperCase().search('FURTO') != -1 && !this.possuiRouboFurtoFederal ? this.possuiRouboFurtoFederal = true : false;
        this.consulta.restricao.toUpperCase().search('ROUBO FURTO') != -1 && !this.possuiRouboFurtoFederal ? this.possuiRouboFurtoFederal = true : false;
        this.consulta.restricao.toUpperCase().search('ROUBO E FURTO') != -1 && !this.possuiRouboFurtoFederal ? this.possuiRouboFurtoFederal = true : false;
        this.consulta.restricao.toUpperCase().search('VEICULO COM OCORRENCIA DE FURTO/ROUBO') != -1 && !this.possuiRouboFurtoFederal ? this.possuiRouboFurtoFederal = true : false;
      }
      if( this.consulta.ocorrencia ) {
        this.consulta.ocorrencia.toUpperCase().search('NÃO') == -1
          && this.consulta.ocorrencia.toUpperCase().search('NAO') == -1
          && this.consulta.ocorrencia.toUpperCase().search('ROUBO') != -1
            && !this.possuiRouboFurtoFederal ? this.possuiRouboFurtoFederal = true : this.possuiRouboFurtoFederal = false;
      }
    }else {
      this.possuiRouboFurtoFederal = false;
    }
  }

  getRestricoes() {
    if (this.listaRestricoes != null) {
      for (let i = 0; i < this.listaRestricoes.length; i++) {
        if (this.listaRestricoes[i].toUpperCase().indexOf("ADMINISTRATIVA") != -1) {
          this.restricaoAdministrativa = this.listaRestricoes[i];
        }else if (this.listaRestricoes[i].toUpperCase().indexOf("ALIENAÇÃO") != -1 || this.listaRestricoes[i].toUpperCase().indexOf("ALIENACAO") != -1) {
          this.alienacao = this.listaRestricoes[i];
        }else if (this.listaRestricoes[i].toUpperCase().indexOf("ARRENDAMENTO") != -1) {
          this.arrendamento = this.listaRestricoes[i];
        }else if ((this.listaRestricoes[i].toUpperCase().indexOf("JUDICIAL") != -1 || this.listaRestricoes[i].toUpperCase().indexOf("RENAJUD") != -1) && this.listaRestricoes[i].toUpperCase().indexOf("NÃO") == -1) {
          this.restricaoJudicial = this.listaRestricoes[i];
        }else if (this.listaRestricoes[i].toUpperCase().indexOf("RESERVA") != -1) {
          this.reservaDominio = this.listaRestricoes[i];
        }else if ((this.listaRestricoes[i].toUpperCase().indexOf("ROUBO FURTO") != -1)
          || (this.listaRestricoes[i].toUpperCase().indexOf("ROUBO E FURTO") != -1)
          || (this.listaRestricoes[i].toUpperCase().indexOf("VEICULO COM OCORRENCIA DE FURTO/ROUBO") != -1)
        ) {
          this.rouboFurto = this.listaRestricoes[i];
        }else if (this.listaRestricoes[i].toUpperCase().indexOf("TRIBUTARI") != -1 || this.listaRestricoes[i].toUpperCase().indexOf("TRIBUTÁRI") != -1) {
          this.restricaoTributaria = this.listaRestricoes[i];
        } else if (this.listaRestricoes[i].toUpperCase().indexOf("CONSTA SINISTRO RECUPERADO") != -1) {
          this.sinistroRecuperado = this.listaRestricoes[i];
        } else {
          this.observacoes += this.listaRestricoes[i] + (i === this.listaRestricoes?.length - 1 ? "" : "; ");
        }

      }
    }
  }

  verificaGravame() {
    this.consulta.nomeAgenteFinanceiro ? this.dadosGravame = true : false;
    this.consulta.nomeFinanciado ? this.dadosGravame = true : false;
    this.consulta.dataInclusaoFinanc ? this.dadosGravame = true : false;
    this.consulta.tipoRestricaoFinanceira ? this.dadosGravame = true : false;
    this.consulta.cpfCnpjFinanciado ? this.dadosGravame = true : false;
  }

}
